import React from 'react'

const Spinner = () => {
  return (
    <>
      <div className="loader">
        <div className="spinner" />
      </div>
      <style>{`
        .loader {
          display: flex;
          justify-content: center;
          align-items: center;
          position: fixed;
          width: 100%;
          height: 100%;
          opacity: 0.8;
          top: 0;
          left: 0;
          z-index: 100;
        }
        .spinner {
          width: 58px;
          height: 58px;
          border-radius: 50%;
          display: inline-block;
          border-top: 4px solid #800020;
          border-right: 4px solid transparent;
          box-sizing: border-box;
          position: relative;
          animation: spin 1s linear infinite;
        }
        .spinner:after {
          content: '';
          box-sizing: border-box;
          position: absolute;
          left: 0;
          top: 0;
          width: 58px;
          height: 58px;
          border-radius: 50%;
          border-left: 4px solid #4a5568;
          border-bottom: 4px solid transparent;
          animation: spin 0.5s linear infinite reverse;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  )
}

export default Spinner
